export default "__VITE_PUBLIC_ASSET__f0ea78f1__"